import { z } from 'zod';
import { isValidUrl, platformIdToSnsType } from './sns-account.service';

// SNS 계정 스키마 정의
const SnsAccountSchema = z
  .object({
    snsType: z
      .string()
      .nullable()
      .transform((val) => (val ? platformIdToSnsType(val) : val)),
    url: z.string(),
  })
  .refine(
    (data) => {
      if (data.snsType === 'ETC' && data.url.trim()) {
        return isValidUrl(data.url.trim()) || isValidUrl(`https://${data.url.trim()}`);
      }
      return true;
    },
    {
      message: 'ETC 타입은 올바른 URL 형식이어야 합니다. (예: https://example.com)',
      path: ['url'],
    },
  );

// SNS 폼 전체 스키마
export const SNSFormSchema = z.object({
  snsAccounts: z
    .array(SnsAccountSchema)
    .min(1)
    .max(2)
    .refine(
      (accounts) => {
        const firstAccount = accounts[0];
        if (!firstAccount || !firstAccount.snsType || !firstAccount.url.trim()) {
          return false;
        }

        // 2번째 계정이 존재하면 반드시 완성되어야 함
        if (accounts.length > 1) {
          const secondAccount = accounts[1];
          if (!secondAccount.snsType || !secondAccount.url.trim()) {
            return false;
          }
        }

        return true;
      },
      {
        message: 'SNS 계정 정보를 완성해주세요',
      },
    ),
});

export type SNSFormData = z.infer<typeof SNSFormSchema>;
export type SnsAccountData = z.infer<typeof SnsAccountSchema>;

export const validateSNSForm = (formData: {
  snsAccounts: { snsType: string | null; url: string }[];
}): boolean => {
  const result = SNSFormSchema.safeParse(formData);
  return result.success;
};
